const ENDPOINTS = {
  BASE_URL: import.meta.env.VITE_BASE_URL,
  AUTH: {
    REGISTER: "/api/auth/register",
    LOGIN: "/api/auth/login",
    LOGOUT: "/api/auth/logout",
    REFRESH_TOKEN: "/api/auth/refresh",
    VERIFY_EMAIL: "/api/auth/verify-email",
    RESEND_VERIFICATION: "/api/auth/resend-verification",
    CHANGE_PASSWORD: "/api/auth/change-password",
    FORGOT_PASSWORD: "/api/auth/forgot-password",
    RESET_PASSWORD: "/api/auth/reset-password",
  },
  PLACES: {
    FETCH_BY_BOUNDS: "/api/places/fetchplacesbybounds",
    FETCH_BY_CATEGORY_AND_BOUNDS: "/api/places/fetchplacesbycategoryandbounds",
    GET_BY_ID: "/api/places/v2",
    GOOGLE_AUTOCOMPLETE: "/api/places/google/autocomplete",
    GOOGLE_NEARBY: "/api/places/google/nearby",
    GOOGLE_DETAILS: (placeId: string) => `/api/places/google/details/${placeId}`,
  },
  CONTRIBUTE: "/api/contribute",
  PROFILE: {
    MAIN: "/api/users/profile",
    EMAIL_CHANGE_REQUEST: "/api/users/profile/email-change-request",
    VERIFY_EMAIL_CHANGE: "/api/auth/verify-email-change",
  },
  SEARCH: "/api/sf/search",
  NOTES: "/api/defaultNotes",
  GENERATE_UPLOAD_URL: "/api/upload/generate-upload-url",
  UPDATE_CONTRIBUTION_VIDEO: "/api/contribute/videos",

  DEFAULT_NOTES: {
    GET_ALL: "/api/defaultnotes",
  },

  CONTRIBUTION: {
    GET_ALL: "/api/contribute",
    GET_BY_ID: (contributionId: string) => `/api/contribute/${contributionId}`,
    UPDATE: (contributionId: string) => `/api/contribute/${contributionId}`,
    FEEDBACK: (contributionId: string) =>
      `/api/contribute/feedback/${contributionId}`,
    DRAFT: (placeId: string) => `/api/contribute/draft/${placeId}`,
  },

  USERS: {
    GET_BY_ID: (userId: string) => `/api/users/${userId}`,
  },

  USER_HISTORY: {
    GET_ALL: "/api/userhistory",
  },

  USER_DEVICES: {
    MAIN: "/api/user-devices",
  },

  RATINGS: {
    CREATE: "/api/ratings",
    FETCH_ALL: (placeId: string) => `/api/ratings/placeratings/${placeId}`,
    RATING_BY_ID: (placeRatingId: string) => `/api/ratings/${placeRatingId}`,
  },

  NOTIFICATIONS: {
    FETCH_ALL: "/api/notifications",
    UNREAD_COUNT: "/api/notifications/unread-count",
    MARK_AS_READ: (notificationId: string) =>
      `/api/notifications/${notificationId}/read`,
  },

  CATEGORIES: {
    GET_ALL: "/api/categories",
  },

  REPORT: {
    CREATE: (contributionId: string | number) =>
      `/api/report/${contributionId}`,
  },

  NAVIGATE: {
    START: (placeId: string | number) =>
      `/api/places/navigate/${placeId}`,
    FEEDBACK: (navHistoryId: string | number) =>
      `/api/places/navigationfeedback/${navHistoryId}`,
  },
} as const;

export default ENDPOINTS;
